import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import ExternalRelationInterestsApi from '@infrastructure/external-relation-interests-api';
export const createExternalRelationInterestAsync = createAsyncThunk('externalrelationInterests/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationInterestsApi.createExternalRelationInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateExternalRelationInterestAsync = createAsyncThunk('externalrelationInterests/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationInterestsApi.updateExternalRelationInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteExternalRelationInterestAsync = createAsyncThunk('externalrelationInterests/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationInterestsApi.deleteExternalRelationInterest(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getExternalRelationInterestByIdAsync = createAsyncThunk('externalrelationInterests/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationInterestsApi.getExternalRelationInterestById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getExternalRelationInterestsByRelationIdAsync = createAsyncThunk('externalrelationInterests/getByRelationId', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationInterestsApi.getExternalRelationInterestsByRelationId(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
